// extracted by mini-css-extract-plugin
export default {"timeline__item":"styles_timeline__item__RiphM","resume__container":"styles_resume__container__ENGev","timeline":"styles_timeline__JaQEJ"};